import { render, staticRenderFns } from "./FictivePalletMaker.vue?vue&type=template&id=313df8d3&scoped=true&"
import script from "./FictivePalletMaker.vue?vue&type=script&lang=js&"
export * from "./FictivePalletMaker.vue?vue&type=script&lang=js&"
import style0 from "./FictivePalletMaker.vue?vue&type=style&index=0&id=313df8d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313df8d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VTextField,VTextarea,VTooltip})
